'use strict';

exports.__esModule = true;
exports.DEFAULT_HEIGHT = exports.DEFAULT_WIDTH = undefined;
exports.buildOgImagePreview = buildOgImagePreview;
exports.buildOgImage = buildOgImage;

var _getByIdentifier = require('../tags/values/get-by-identifier');

var _Identifiers = require('../types/Identifiers');

var _TagTypes = require('../types/TagTypes');

var _Props = require('../types/Props');

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OG_IMAGE = _Identifiers.IDENTIFIERS.OG_IMAGE,
    OG_IMAGE_WIDTH = _Identifiers.IDENTIFIERS.OG_IMAGE_WIDTH,
    OG_IMAGE_HEIGHT = _Identifiers.IDENTIFIERS.OG_IMAGE_HEIGHT;
var DEFAULT_WIDTH = exports.DEFAULT_WIDTH = 2500;
var DEFAULT_HEIGHT = exports.DEFAULT_HEIGHT = 1330;

function buildOgImagePreview(url, width, height) {
  var urlOrName = url;
  if (!urlOrName) {
    return urlOrName;
  }

  if (isAbsoluteUrl(urlOrName)) {
    urlOrName = extractImageNameFromWixMediaUrl(urlOrName);
  }

  if (!urlOrName) {
    return urlOrName;
  }

  return 'https://static.wixstatic.com/media/' + urlOrName + '/v1/fit/w_' + width + ',h_' + height + ',al_c/' + urlOrName;
}

function buildOgImage(tags) {
  var result = { src: '', width: '', height: '' };

  var urlOrName = (0, _getByIdentifier.getValueByIdentifier)(tags, OG_IMAGE);
  if (!urlOrName) {
    return result;
  }

  result.src = urlOrName;
  if (isAbsoluteUrl(urlOrName)) {
    urlOrName = extractImageNameFromWixMediaUrl(urlOrName);
  }

  if (!urlOrName) {
    return result;
  }

  result.src = 'https://static.wixstatic.com/media/' + urlOrName;

  var width = (0, _getByIdentifier.getValueByIdentifier)(tags, OG_IMAGE_WIDTH);
  var height = (0, _getByIdentifier.getValueByIdentifier)(tags, OG_IMAGE_HEIGHT);

  if (width && height) {
    result.src += '/v1/fill/w_' + width + ',h_' + height + ',al_c/' + urlOrName;
  } else {
    var meta = getOgImageMeta(tags);
    if (meta && meta.width && meta.height) {
      var resized = resizeImage(meta.width, meta.height, DEFAULT_WIDTH);
      result.src += '/v1/fill/w_' + resized.width + ',h_' + resized.height + ',al_c/' + urlOrName;
      result.width = '' + resized.width;
      result.height = '' + resized.height;
    } else {
      result.src += '/v1/fit/w_' + DEFAULT_WIDTH + ',h_' + DEFAULT_HEIGHT + ',al_c/' + urlOrName;
    }
  }

  return result;
}

function resizeImage(width, height, maxWidth) {
  width = parseInt(width, 10);
  height = parseInt(height, 10);
  if (width > maxWidth) {
    return {
      width: maxWidth,
      height: Math.floor(height / width * maxWidth)
    };
  }
  return { width: width, height: height };
}

function getOgImageMeta(tags) {
  var ogImage = tags.find(function (tag) {
    var type = tag.type,
        _tag$props = tag.props,
        props = _tag$props === undefined ? {} : _tag$props;

    if (type === _TagTypes.TAG_TYPES.META) {
      return props[_Props2.default.PROPERTY] === 'og:image';
    }
    return false;
  });
  return (ogImage || {}).meta;
}

function isAbsoluteUrl(url) {
  return (/^https?/.test(url) || /^\/\//.test(url)
  );
}

function extractImageNameFromWixMediaUrl(url) {
  var pattern = 'static.wixstatic.com/media/';
  var index = url.indexOf(pattern);
  if (index !== -1) {
    var name = url.substr(index + pattern.length);
    if (name.indexOf('/') !== -1) {
      return '';
    }
    return name;
  }
  return '';
}